export default __webpack_public_path__ + "static/media/winter2.68e68c28.png";